module.exports = __webpack_public_path__ + "media/团侧.3e797f5f.mp4";